var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClockGray5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M8.00016 1.33594C11.6822 1.33594 14.6668 4.32127 14.6668 8.0026C14.6668 11.6839 11.6822 14.6693 8.00016 14.6693C4.31816 14.6693 1.3335 11.6839 1.3335 8.0026C1.3335 4.32127 4.31816 1.33594 8.00016 1.33594ZM8.00016 2.44727C4.93683 2.44727 2.44483 4.93927 2.44483 8.0026C2.44483 11.0659 4.93683 13.5579 8.00016 13.5579C11.0635 13.5579 13.5555 11.0659 13.5555 8.0026C13.5555 4.93927 11.0635 2.44727 8.00016 2.44727ZM7.50016 4.0026C7.75316 4.0026 7.96247 4.19083 7.9956 4.43479L8.00016 4.5026V8.0026H10.1668C10.4428 8.0026 10.6668 8.2266 10.6668 8.5026C10.6668 8.7556 10.4786 8.96491 10.2346 8.99804L10.1668 9.0026H7.50016C7.24716 9.0026 7.03786 8.81438 7.00473 8.57042L7.00016 8.5026V4.5026C7.00016 4.2266 7.22416 4.0026 7.50016 4.0026Z",
    fill: "#5E696E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClockGray5);
export default __webpack_public_path__ + "static/media/icon-clock-gray5.80ae15cd48205fd16552f79ca1130c44.svg";
export { ForwardRef as ReactComponent };